import React from "react";
import Container from "@material-ui/core/Container";
import BuccaneerHeader from "../components/Home/BuccaneerHeader";
import SaleTopContainer from "../components/Sale/SaleTopContainer";
import styled from "styled-components";
import SaleInfo from "../components/Sale/SaleInfo";
import { useTranslation } from "react-i18next";

interface Props {
  connect: () => void;
  setIsHide: (e: any) => void;
  killSession: () => void;
  isHide: boolean;
  connected: boolean;
  address: string;
  chainId: number;
}

export const Description = styled.p`
  font-size: 20px;
  color: #fafafa;
  font-family: "Montserrat-Regular";
  margin: 2em 0;
  leter-spacing: 3px;
  line-height: 28px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Sale = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg">
      <BuccaneerHeader
        connect={props.connect}
        isHide={props.isHide}
        setIsHide={(e: any) => props.setIsHide(e)}
        connected={props.connected}
        address={props.address}
        chainId={props.chainId}
        killSession={props.killSession}
      />
      <SaleTopContainer isHide={props.isHide} />
      <SaleInfo />
      <Description style={{ textDecoration: "underline" }}>
        {t("Disclaimer")}
      </Description>
      <Description>{t("SaleDesc1")}</Description>
      <Description>{t("SaleDesc2")}</Description>
    </Container>
  );
};

export default Sale;
